<template>
  <div>
    <div v-if="show" class="box">
      <h3>科室消耗总汇（按计费）同比环比图</h3>
      <h5>科室：{{title}}  <span>日期范围：{{time}}</span></h5>
      <div class="center" id="app1"></div>
      <div class="btn1">
        <el-button size="small" @click="closeEvt">取 消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:['show','data','title','time'],
  data () {
    return {
      dialogVisible: true,

    };
  },
  mounted () {
    var chartDom = document.getElementById('app1');
    var myChart = this.$echarts.init(chartDom);
    var option;

    option = {
      title: {
        text: ``,
      },
  legend: {
  data:[ '同比期', '环比期', '本期'],
  left:'60%'
  },
  tooltip: {},
  dataset: {
    // dimensions: ['name',],
    source: this.data
  },
  xAxis: { type: 'category', axisLabel: { interval: 0, rotate: 30 } },
  yAxis: {
        type: 'value',
        name: '金额（元）'
  },
  // Declare several bar series, each will be mapped
  // to a column of dataset.source by default.
  series: [{ type: 'bar' }, { type: 'bar' }, { type: 'bar' }]
};
    myChart.setOption(option);
  },
  methods: {
    init () {
      let app = document.getElementById('app1')
      let myChart = this.$echarts.init(app)

      myChart.setOption(this.option);
    },
    closeEvt(){
      this.$emit('closeEvt',false)
    }
  }
};
</script>

<style scoped lang="scss">


.box {
  padding: 15px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 880px;
  height: 660px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px #000;
  h5{
    padding-left: 30px;
    span{
      padding-left: 15px;
    }
  }
  .center{
    margin: 10px auto;
    width: 760px;
    height: 500px;
  }
  .btn1{
    float: right;
  }
}
</style>

